import React, { useCallback, useState } from 'react'
import { ReactComponent as BurgerSvg } from 'images/icons/burger_icon.svg'
import { ReactComponent as UserSvg } from 'images/icons/user_pic.svg'

import Menu from '../Menu/Menu'

import s from './HeaderWithMenu.module.scss'

type Props = {
  title: string
}

const HeaderWithMenu = ({ title }: Props) => {
  const [menuOpened, setMenuOpened] = useState<boolean>(false)
  const onBurgerClick = useCallback(() => setMenuOpened(true), [])
  return (
    <>
      <div className={s.container}>
        <div className={s.left} onClick={onBurgerClick}>
          <BurgerSvg />
        </div>
        <div className={s.title}>{title}</div>
        <div className={s.right}>{/* <UserSvg /> */}</div>
      </div>
      <Menu opened={menuOpened} setOpened={setMenuOpened} />
    </>
  )
}

export default React.memo(HeaderWithMenu)
